import httpClient from "../../../utils/httpClient";

export interface CreatePAPayload {
  [key: string]: any;
}

export interface UpdatePAPayload {
  [key: string]: any;
}

export interface SaveNotePayload {
  ProfitAnalysisId: number;
  JobId: number | null;
  Note: string;
}

export const profitAnalysisApi = {
  listJobs: () =>
    httpClient.get(`/api/jobs/`),

  createPA: (payload: CreatePAPayload) =>
    httpClient.post(`/api/profit-analyses/`, payload),

  updatePA: (id: string, payload: UpdatePAPayload) =>
    httpClient.put(`/api/profit-analyses/${id}`, payload),

  getPADetails: (id: string) =>
    httpClient.get(`/api/profit-analyses/${id}/details`),

  saveNote: (payload: SaveNotePayload) =>
    httpClient.post(`/api/profit-analysis/note`, payload),
};
